import { type ValueOf } from 'Types';

import { FEATURE_TRACKING_ID as RELATIONSHIP_INTENT_FEATURE_TYPE } from 'Containers/RelationshipIntent/constants';

export const BOTTOM_SHEET_DESCRIPTOR = 'descriptor';
export const BOTTOM_SHEET_QUIZ = 'quiz';
export const RELATIONSHIP_INTENT_DESCRIPTOR = 'de_29';
export const HEIGHT_MEASUREMENT_DESCRIPTOR = 'de_30';

export const BOTTOM_SHEET_KEY = 'bottom_sheet';

export const EDIT_PROFILE_BOTTOM_SHEET_MAPPING = {
  [BOTTOM_SHEET_DESCRIPTOR]: {
    name: BOTTOM_SHEET_DESCRIPTOR,
    type: BOTTOM_SHEET_DESCRIPTOR,
  },
  [BOTTOM_SHEET_QUIZ]: {
    name: BOTTOM_SHEET_QUIZ,
    //  TODO: SPARKS-M1: Should type be the specific quiz?
    type: BOTTOM_SHEET_QUIZ,
  },
  [RELATIONSHIP_INTENT_DESCRIPTOR]: {
    name: RELATIONSHIP_INTENT_DESCRIPTOR,
    type: RELATIONSHIP_INTENT_FEATURE_TYPE,
  },
  [HEIGHT_MEASUREMENT_DESCRIPTOR]: {
    name: HEIGHT_MEASUREMENT_DESCRIPTOR,
    type: '',
  },
} as const;

export const SUPPORTED_BOTTOM_SHEET_KEYS = [
  BOTTOM_SHEET_DESCRIPTOR,
  BOTTOM_SHEET_QUIZ,
  RELATIONSHIP_INTENT_DESCRIPTOR,
  HEIGHT_MEASUREMENT_DESCRIPTOR,
];

export type SupportedBottomSheet = keyof typeof EDIT_PROFILE_BOTTOM_SHEET_MAPPING;
export type EditProfileBottomSheetConfigs = ValueOf<typeof EDIT_PROFILE_BOTTOM_SHEET_MAPPING>;
